export default __webpack_public_path__ + "static/media/me-icon.b9e81f99.webp";